'use client';

import { useTranslation } from '@root/src/i18n/client';
import CollectionTitle from '../collection/collectiontitile';
import HeroBanner from '../collection/herobannertop';
import AdminResponsiveBanner from '../common/AdminResponsiveBanner';
import ProductGrid from '../collection/productionGrid';
import RelatedCategories from './relatedCategories';
import HeroBannerBottomCategory from './HeroBannerBottomCategory';

interface CategoryPageProps {
  category?: {
    id?: string | number;
    name?: string;
    description?: string;
    slug?: string;
    image?: string[] | string;
    appear?: string;
    order?: string | number;
  };
  products?: Array<any>;
  relatedCategories?: Array<any>;
}

export default function CategoryPage({
  category,
  products = [],
  relatedCategories = [],
}: CategoryPageProps) {
  const { t } = useTranslation('common');

  const categoryData: {
    name: string;
    description?: string;
    image?: string[] | string;
  } = {
    name: category?.name || t('lytra.categoryFallbackName'),
    description: category?.description || t('lytra.categoryFallbackDesc'),
    image: category?.image,
  };

  const categoryImages = Array.isArray(categoryData.image)
    ? categoryData.image.filter(Boolean)
    : [];
  const bannerDesktop = categoryImages[1];
  const bannerTablet = categoryImages[2] || categoryImages[1];
  const bannerMobile = categoryImages[3] || categoryImages[2] || categoryImages[1];

  return (
    <div className="page-wrapper lytra-collection-page">
      {bannerDesktop ? (
        <AdminResponsiveBanner
          alt={categoryData.name}
          desktopSrc={bannerDesktop}
          tabletSrc={bannerTablet}
          mobileSrc={bannerMobile}
          priority
          sizes="100vw"
          backgroundColor="#f5eee0"
        />
      ) : (
        <HeroBanner collection={categoryData} />
      )}
      <CollectionTitle collection={categoryData} />
      <ProductGrid parentSlug={category?.slug} products={products} />
          <HeroBannerBottomCategory collection={categoryData} />
      <div className="other-collections-wrapper">
        <RelatedCategories categories={relatedCategories} />
      </div>
    </div>
  );
}
